import React, { useEffect, useMemo, useState } from 'react';
import { Typography, Layout, Col, Row, theme, Spin, Alert, Grid } from 'antd';
import AppHeader from '../layout/AppHeader';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { getUser } from '../../apis/apis';
import DOMPurify from 'dompurify';
import { useTranslation } from "react-i18next";


const { Title, Paragraph } = Typography;

const SupportInfo: React.FC = () => {  
    const screens = Grid.useBreakpoint();
  const isMobile = !screens.lg;
  const { token } = theme.useToken();
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');
  const { t, i18n } = useTranslation();
  const LANGUAGE = i18n.resolvedLanguage || i18n.language;
  
  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const user = await getUser();
        if (!user?.clientId) {
          if (isMounted) {
            setError('No se pudo obtener el cliente.');
            setContent('');
          }
          return;
        }
        const clientRef = doc(db, 'Clients', user.clientId);
        const snap = await getDoc(clientRef);
        if (!isMounted) return;
        if (snap.exists()) {
          const data: any = snap.data();
          let text = '';
          if (data.contactInfo && typeof data.contactInfo === 'object' && data.contactInfo[LANGUAGE]) {
            text = data.contactInfo[LANGUAGE];
          } else{
            text = '';
          }
          setContent(String(text || ''));
        } else {
          setContent('');
        }
      } catch {
        if (isMounted) {
          setError('Error cargando contactInfo del cliente');
          setContent('');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [LANGUAGE]);

  const hasHtml = useMemo(() => /<\/?[a-z][\s\S]*>/i.test(content), [content]);

  const safeHtml = useMemo(() => {
    if (!hasHtml) return '';
    return DOMPurify.sanitize(content, { USE_PROFILES: { html: true } });
  }, [content, hasHtml]);

  const formattedPlain = useMemo(() => {
    if (hasHtml) return '';
    let t = content.replace(/\r\n/g, '\n').trim();
    t = t.replace(/(\?)\s+(?=[A-ZÁÉÍÓÚÑ0-9“"¿¡])/g, '$1\n');
    t = t.replace(/\n{2,}/g, '\n\n');
    t = t.replace(/\n(\d+\.\s)/g, '\n\n$1');
    return t;
  }, [content, hasHtml]);

  return (
    <Layout style={{ display: 'flex', flexDirection: 'column', minHeight: '100svh', background: token.colorBgBase }}>
     <AppHeader position={isMobile ? 'fixed' : 'sticky'} />
      <Row style={{ height: '100%' }}>
        <Col span={24} style={{ height: '100%'}}>
          <div style={{ overflowY: 'auto', height: '100%', padding: 25, paddingBottom: 80 }}>
            <Title level={2} style={{marginTop: '50px'}}>{t("support.title")}</Title>
            {loading ? (
              <Spin />
            ) : error ? (
              <Alert type="error" message={error} />
            ) : content ? (
              hasHtml ? (
                <div dangerouslySetInnerHTML={{ __html: safeHtml }} />
              ) : (
                <Paragraph style={{ whiteSpace: 'pre-wrap', marginBottom: 0 }}>{formattedPlain}</Paragraph>
              )
            ) : (
              <Paragraph></Paragraph>
            )}
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default SupportInfo;
